var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateCw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 9.25a.75.75 0 0 1 .75.75A9.083 9.083 0 0 1 10 19.083a.75.75 0 0 1 0-1.5A7.583 7.583 0 0 0 17.583 10a.75.75 0 0 1 .75-.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.917 10A9.066 9.066 0 0 1 10 .917c2.998 0 5.244 1.24 6.727 2.463.32.264.605.527.856.779v-.826a.75.75 0 0 1 1.5 0V6.25a.75.75 0 0 1-.75.75h-2.916a.75.75 0 0 1 0-1.5h1.375c-.277-.3-.617-.631-1.02-.963-1.294-1.069-3.215-2.12-5.772-2.12A7.566 7.566 0 0 0 2.417 10 7.583 7.583 0 0 0 10 17.583a.75.75 0 1 1 0 1.5A9.083 9.083 0 0 1 .917 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCw);
export default __webpack_public_path__ + "static/media/rotate-cw.64eec3356cea47dccc426215e64bff81.svg";
export { ForwardRef as ReactComponent };